import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";

const Tabing = ({ bottomTabs, style, className, activeKey, onChange = () => { }, defaultActive, isExtraComponent = false, ExtraComponent = () => { } }) => {
  const [activeTab, setActiveTab] = useState("/");
  const location = useLocation();

  useEffect(() => {
    let current = bottomTabs.find(
      (tab) => tab.url && location.pathname.startsWith(tab.url)
    );

    if (current && !defaultActive) {
      setActiveTab(current.activeKey);
    } else {
      if (defaultActive) {
        setActiveTab(defaultActive);
      } else {
        setActiveTab(bottomTabs[0]?.activeKey || "");
      }
    }
  }, [location.pathname, bottomTabs, defaultActive]);

  // useEffect(() => {
  //     let current = bottomTabs.find(tab =>
  //         tab.url && location.pathname.startsWith(tab.url)
  //     );

  //     if (current) {
  //         setActiveTab(current.activeKey);
  //     } else {
  //         // fallback for cases where url is empty or path doesn't match
  //         if (bottomTabs[5]?.activeKey === 'employee-directory') {
  //             setActiveTab(bottomTabs[5]?.activeKey || "");
  //         } else {
  //             setActiveTab(bottomTabs[0]?.activeKey || "");
  //         }
  //     }
  // }, [location.pathname, bottomTabs]);

  return (
    <div
      className={`${style.headerBottom_tabs} ${className?.headerBottom_tabs}`}
    >
      {bottomTabs?.map((eachTab, i) => {
        return (
          <Link
            key={i}
            to={eachTab?.url}
            className={`${style.headerBottom_tabs__items}  ${
              className?.headerBottom_tabs__items
            } ${activeTab === eachTab?.activeKey ? style.active : ""}`}
            onClick={(e) => {
              if (!eachTab?.url) {
                e.preventDefault(); // 👈 prevent navigation
                return;
              }
              setActiveTab(eachTab?.activeKey);
            }}
          >
            <span>{eachTab?.name}</span>
          </Link>
        );
      })}

      {isExtraComponent ? (
        <ExtraComponent
          className={`${style.headerBottom_tabs__items} ${className?.headerBottom_tabs__items}`}
        />
      ) : null}
    </div>
  );
};

export default Tabing;
